import React from "react";


export const TrueFalseColumnFormatter = (value) => {
    return <span  className={`label label-lg text-uppercase label-inline ${value ? 'bg-green' : 'bg-danger'}`}>
        {value ? 'True' : 'False'}</span>
};

